import { Skeleton } from '@chakra-ui/react';
import { useCurrentColors } from '../../hooks/UseCurrentColors/UseCurrentColors';
export default function SkeletonWarpper(props: any) {
    const currentColor = useCurrentColors();
    return (
        <Skeleton
            startColor={currentColor.brand['999']}
            endColor={currentColor.brand['900']}
            {...props}
        />
    );
}
